import {SketchConstraintFormulaRegistry} from './SketchConstraintFormulaRegistry';
import {SketchCurveConstraintFormulaCompiler} from './SketchCurveConstraintFormulaCompiler';
import {SketchFixedConstraintFormulaCompiler} from './SketchFixedConstraintFormulaCompiler';
import {SketchExternalReferenceFormulaCompiler} from './SketchExternalReferenceFormulaCompiler';
import {SketchEntitySymmetricConstraintFormulaCompiler} from './SketchEntitySymmetricConstraintFormulaCompiler';
import {SketchLineConstraintFormulaCompiler} from './SketchLineConstraintFormulaCompiler';
import {SketchNumericConstraintFormulaCompiler} from './SketchNumericConstraintFormulaCompiler';
import {SketchPointConstraintFormulaCompiler} from './SketchPointConstraintFormulaCompiler';
import {SketchSlotConstraintFormulaCompiler} from './SketchSlotConstraintFormulaCompiler';
import {SketchSplineConstraintFormulaCompiler} from './SketchSplineConstraintFormulaCompiler';
import {SketchPatternConstraintFormulaCompiler} from './SketchPatternConstraintFormulaCompiler';

/**
 * 默认草图关系公式注册表工厂。
 *
 * 本类是公式编译器的唯一默认装配点。island builder 依赖可注入注册表，测试、离线 SDK
 * 或后续插件可以传入显式注册表；生产默认集合不得在多个调用方重复维护。
 */
export class SketchDefaultConstraintFormulaRegistryFactory {
    /**
     * 创建完整的默认公式注册表。
     *
     * @returns 已登记当前内部草图关系公式编译器的注册表。
     */
    public create(): SketchConstraintFormulaRegistry {
        return new SketchConstraintFormulaRegistry([
            new SketchLineConstraintFormulaCompiler(),
            new SketchPointConstraintFormulaCompiler(),
            new SketchCurveConstraintFormulaCompiler(),
            new SketchSplineConstraintFormulaCompiler(),
            new SketchSlotConstraintFormulaCompiler(),
            new SketchNumericConstraintFormulaCompiler(),
            new SketchFixedConstraintFormulaCompiler(),
            new SketchExternalReferenceFormulaCompiler(),
            new SketchPatternConstraintFormulaCompiler(),
            new SketchEntitySymmetricConstraintFormulaCompiler(),
        ]);
    }
}
